module.exports = __webpack_public_path__ + "static/media/vouchers-instructions.bcab0a2b.png";